// import moment from 'moment'

/**
 * Formats the given number according to the user locale
 * @param value Number to be formatted
 * @param opts (Optional) Intl.NumberFormatOptions
 * @returns Formatted number
 */
export const formatNumber = (
  value: number,
  precision = 2,
  opts?: Intl.NumberFormatOptions,
) => {
  const number =
    (value && precision && parseFloat(value?.toFixed(precision))) || value || 0

  return new Intl.NumberFormat('en-US', {
    ...opts,
    maximumFractionDigits: precision,
  }).format(number)
}
/**
 * Rounds a number to a specified precision (number of decimal places).
 *
 * @param {number} num - The number to be rounded.
 * @param {number} [precision=2] - The number of decimal places to round to (defaults to 2 if not provided).
 * @returns {number} - The rounded number.
 *
 * @example
 * // Returns 6.12
 * roundNumberTo(6.12311231, 2);
 *
 * @example
 * // Returns 9.99
 * roundNumberTo(9.99229994);
 */
export const roundNumberTo = (num: number, precision = 2) =>
  Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision)

/**
 * Parse a localized number to a float.
 * @param {string} stringNumber - the localized number
 */
export const parseNumber = (stringNumber: string) => {
  const locale = 'en-US'
  const thousandSeparator = Intl.NumberFormat(locale)
    .format(11111)
    .replace(/\p{Number}/gu, '')
  const decimalSeparator = Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, '')

  return parseFloat(
    stringNumber
      .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
      .replace(new RegExp('\\' + decimalSeparator), '.'),
  )
}

/**
 * Formats the given date according to the user locale
 * @param value Date to be formatted
 * @param opts (Optional) Intl.DateTimeFormatOptions
 * @returns Formatted date
 */
export const formatDate = (
  date: Date | string | number,
  opts?: Intl.DateTimeFormatOptions,
  locale = 'en-US',
) => {
  const realDate =
    typeof date === 'string' || typeof date === 'number' ? new Date(date) : date

  return new Intl.DateTimeFormat(locale, opts).format(realDate)
}

export const secondsToMinutes = (seconds: number) => {
  return Math.round(seconds / 60)
}

// export const formatTimeGap = (initial: string | Date, now: Date) => {
//   return moment.duration(moment(initial).diff(moment(now))).humanize()
// }
